import React from 'react'
import { MainCtn } from '../../layouts/Main/MainStyles'
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import PhotoGrid from '../../components/main/PhotoGrid';

import img_01 from '../../data/images/album/1.png';
import img_02 from '../../data/images/album/2.png';
import img_03 from '../../data/images/album/3.png';
import img_04 from '../../data/images/album/4.png';
import img_05 from '../../data/images/album/5.png';
import img_06 from '../../data/images/album/6.png';
import img_07 from '../../data/images/album/7.png';
import img_08 from '../../data/images/album/8.png';
import img_09 from '../../data/images/album/9.png';
import img_10 from '../../data/images/album/10.png';
import img_11 from '../../data/images/album/11.png';
import img_12 from '../../data/images/album/12.png';
import img_13 from '../../data/images/album/13.png';
import img_14 from '../../data/images/album/14.png';
import img_15 from '../../data/images/album/15.png';
import img_16 from '../../data/images/album/16.png';



const mockLeftGrid = [
    {
    image: img_01,
    description: 'test',
    title: 'test',
    },
    {
    image: img_02,
    description: 'test',
    title: 'test',
    },
    {
    image: img_03,
    description: 'test',
    title: 'test',
    },
    {
    image: img_04,
    description: 'test',
    title: 'test',
    },
];

const mockMiddleGrid = [
    {
    image: img_08,
    description: 'test',
    title: 'test',
    },
    {
    image: img_05,
    description: 'test',
    title: 'test',
    },
    {
    image: img_07,
    description: 'test',
    title: 'test',
    },
    {
    image: img_06,
    description: 'test',
    title: 'test',
    },
];

const mockRightGrid = [
    {
    image: img_09,
    description: 'test',
    title: 'test',
    },
    {
    image: img_10,
    description: 'test',
    title: 'test',
    },
    {
    image: img_11,
    description: 'test',
    title: 'test',
    },
    {
    image: img_12,
    description: 'test',
    title: 'test',
    },
];


const PhotoPage = () => {
    return (
        <>
            <MainCtn>
                <Box 
                    sx={{ 
                        marginTop: 15, 
                        // border: '1px solid black',
                        width: '100%',
                        height: '100%',
                        padding: '3em'
                        }}>
                    <Grid container spacing={4}>
                        <Grid item xs={12} md={12}>
                            <Typography
                                sx={{
                                    textAlign: 'center',
                                    fontSize: '50px',
                                    fontWeight: 600,
                                    fontFamily: 'Poppins',
                                    letterSpacing: -1,
                                    '@media (max-width: 1300px)': {
                                        fontSize: '2em',

                                    }
                                }}
                            >
                                Yonsei Photo
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <PhotoGrid data={mockLeftGrid} />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <PhotoGrid data={mockMiddleGrid} />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <PhotoGrid data={mockRightGrid} />
                        </Grid>
                    </Grid>
                </Box>
            </MainCtn>
        </>
    )
}

export default PhotoPage